import React, { Component } from 'react'

import theme from '../../theme'
import './intro.css'
import elizabethcircle from '../../assets/elizabethcircle.png'
import { withRouter } from 'react-router-dom'

class Intro extends Component {
  go() {
    this.props.history.push('/home')
  }

  keyPressGo(event) {
    if (event.key === 'Enter') {
      this.go()
    }
  }

  render() {
    return (
      <div
        style={{
          display: 'flex',
          position: 'absolute',
          width: '100vw',
          height: '100vh',
          zIndex: 11,
          color: theme.colors.palePurple,
          backgroundColor: theme.colors.white,
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <img
          src={elizabethcircle}
          alt=""
          min-height="200px"
          min-width="200px"
          height="200px"
          width="200px"
          pt="20px"
          pb="20px"
        />
        <h1 style={{ fontFamily: theme.fonts.header.family }}>
          Hi! I’m Elizabeth.
        </h1>
        <div
          style={{
            fontFamily: theme.fonts.primary.family,
            weight: theme.fonts.primary.weight,
            padding: '0 5% 0 5%'
          }}
        >
          <b>What I{`'`}ve been up to lately:</b>
          <br />
          Consulting | PwC
          <br />
          Harp | American Harp Society 2021-2023 Concert Artist
          <br />
          •••
          <br />
          <b>Recent history:</b>
          <br />
          Harvard | CS
          <br />
          New England Conservatory | Harp Performance
        </div>
        <br />
        <br />
        <div className="container">
          <div
            className="animated bounce"
            onClick={this.go.bind(this)}
            onKeyPress={this.keyPressGo.bind(this)}
            role="button"
            tabIndex={0}
            style={{
              cursor: 'default',
              textDecoration: 'none'
            }}
          >
            ➜
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(Intro)



// WEBPACK FOOTER //
// ./src/containers/Intro/index.js